// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapIcon } from '../../../dsl/front'

@Component({
  name: 'ReadingTime',
  components: { BootstrapIcon },

  template: `
    <div class="reading-time">
      <BootstrapIcon name="clock" />
      {{time}} min.
    </div>
  `
})
export class ReadingTime extends Vue {
  @Prop({ type: Number, required: true })
  public readonly time!: number
}
